import apiClient from '@/api/index'
import router from '@/router';

export const fastSetsModule = {
    namespaced: true,

    state:() => ({
        isLoading: true,
        points_of_sale: null,
    }),

    mutations: {
        
    },

    actions: {
        async getPointOfSale({}) {
            return apiClient.get("/projects/tcode/shops/", {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                for(let i = 0; i < response.data.length; i++) {
                    response.data[i].label = response.data[i].name
                    response.data[i].value = response.data[i].code
                }

                return response.data
            })
            .catch((error) => {
                console.log(error);
            });
        },
        
        async fetchFastSets({}, customQuery) {
            const shop = router.currentRoute.value.query.shop || router.currentRoute.value.params.shop;
            const project = router.currentRoute.value.query.project || router.currentRoute.value.params.project;
            const queryString = router.currentRoute.value.fullPath.split('?')[1];
            const queryPart = queryString ? queryString : '';

            return apiClient.get(`/projects/${project}/shops/${shop}/fast-sets/?${queryPart ? queryPart : customQuery}`, {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                .then((response) => {
                    return response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        async fetchCurrentSet({}, data) {
            
            return apiClient.get(`/projects/${data.project}/shops/${data.shop}/fast-sets/${data.id}?all=true`, {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                console.log(error);
            });
        },

        async fetchProducts({}, customQuery) {
            const shop = router.currentRoute.value.query.shop || router.currentRoute.value.params.shop;
            const project = router.currentRoute.value.query.project || router.currentRoute.value.params.project;
            const queryString = router.currentRoute.value.fullPath.split('?')[1];
            const queryPart = queryString ? queryString : '';

            return apiClient.get(`/projects/${project}/shops/${shop}/products/?${queryPart ? queryPart : customQuery}`, {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                .then((response) => {
                    return response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        async editFastSet({}, data) {
            const shop = router.currentRoute.value.query.shop || router.currentRoute.value.params.shop
            const project = router.currentRoute.value.query.project || router.currentRoute.value.params.project

            return apiClient
            .patch(`/projects/${project}/shops/${shop}/fast-sets/${data.id}/?all=true`,
                data.formData,
                {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                return response
            })
            .catch((error) => {
                console.log(error);
            });
        },
    }
}